import EliminationResultRow from "./EliminationResultRow";
import FinalResultRow from "./FinalResultRow";
import React from "react";
import ResultsTableHead from "./ResultsTableHead";
import ResultsTableHeader from "./ResultsTableHeader";
import { JudgeResult, Result, RoundType } from "../../interfaces/ICompetitions";
import { sortRoundResults } from "../../utils/resultHelpers";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

interface ResultsTableProps {
  results: Result[];
  roundType: RoundType;
  roundName?: string;
  categoryName?: string;
  judges?: JudgeResult[];
  onBack?: () => void;
}

export default function ResultsTable({
  results,
  roundType,
  roundName,
  categoryName,
  judges,
  onBack,
}: ResultsTableProps) {
  const sortedResults = sortRoundResults(results, roundType);
  const hasHeader = !!(roundName || categoryName || onBack);
  const colSpan = roundType === RoundType.FINAL ? 3 : 2;

  return (
    <Paper>
      {hasHeader && (
        <ResultsTableHeader
          roundName={roundName}
          categoryName={categoryName}
          judges={judges}
          onBack={onBack}
        />
      )}
      <TableContainer>
        <Table>
          <TableHead>
            <ResultsTableHead roundType={roundType} />
          </TableHead>
          <TableBody>
            {sortedResults.length === 0 ? (
              <TableRow>
                <TableCell colSpan={colSpan} align="center" sx={{ py: 4 }}>
                  <Typography variant="body2" color="text.secondary">
                    Brak wyników
                  </Typography>
                </TableCell>
              </TableRow>
            ) : roundType === RoundType.FINAL ? (
              sortedResults.map((result, index) => <FinalResultRow key={index} result={result} />)
            ) : (
              sortedResults.map((result, index) => (
                <EliminationResultRow key={index} result={result} />
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
}
